import { Position, State } from 'src/types'
import { lace } from 'src/features/dxm/drawer/rightThrow/glove/back/lace'
import { lining } from 'src/features/dxm/drawer/rightThrow/glove/back/lining'
import { littleHook } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerHooks/littleHook'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerHooks/thumbHook'
import { webOfGloveBackDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/web/useCanvasWebsBack'
import { loopOfRingFingerDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/loopOfRingFinger'
import { backStyleOfGloveBackDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/backStyles'
import { laceOfWristBeltCrossDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/lace/laceOfWristBeltFix'
import { liningEmbroideryDrawer, nonThumbEmbroideryDrawer } from 'src/features/dxm/drawer/common/back/useCanvasEmbroideries'
import { canvasResetter } from 'src/util/canvas'
import { fingerGuardDrawer } from 'src/features/dxm/drawer/rightThrow/glove/back/fingerCoverOrPad/fingerGuardDrawer'
import { dxmLabel } from 'src/features/dxm/drawer/rightThrow/glove/back/label'

export const dxmCanvasGloveBack = (ctx: CanvasRenderingContext2D, state: State, position: Position): void => {
  // リセット
  canvasResetter(ctx)
  // 裏革
  lining(ctx, state.linings?.color)
  // 薬指リング // カラー指定どうするか
  loopOfRingFingerDrawer(ctx, state?.loopOfRingFingerColor?.color, state.stitch.color, state.loopOfRingFinger?.value)
  // 平裏の刺繍描画1段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'first')
  // 平裏の刺繍描画2段目
  liningEmbroideryDrawer(ctx, state.embroideries, 'second')
  // バックスタイルの描画(ハミダシ,親指刺繍含)
  backStyleOfGloveBackDrawer(ctx, state, position)
  // 指カバー・パッド
  fingerGuardDrawer(ctx, state)
  // 小指への刺繍
  nonThumbEmbroideryDrawer(ctx, 'childFinger', state.embroideries)
  // 親指掛け紐_上
  thumbHook(ctx, state.thumbHook?.color, 110, -310, 15) // 先端
  // ウェブの描画
  webOfGloveBackDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color)

  laceOfWristBeltCrossDrawer(ctx, state.lace?.color)
  // ラベル描画
  switch (state.backStyle?.value) {
    case 'dWave':
      dxmLabel(ctx, state, -310, 260, -40, 0.9)
      break
    default:
      dxmLabel(ctx, state, 0, 0, 0, 1)
      break
  }
  // 小指掛け紐
  littleHook(ctx, state.littleHook?.color, 25, 240, -10, 0.7)
  thumbHook(ctx, state.thumbHook?.color, -14, 30, 0) //手元
}
